import { CardComponentProps } from "@~/types/types";
import {
  transformVariantPriceRange,
  isPriceAtLeastMinimumThreshold,
  getCreditMessage,
} from "./utils";
import {
  transformPricePerUnit,
  allVariantsHaveSamePrice,
} from "../__shared__/PriceUtils/priceUtils";
import { PricePresentation } from "../__shared__/PriceUtils/PricePresentation";

export function Price({
  product,
  configProps,
}: Pick<CardComponentProps, "product" | "configProps">) {
  const { variantPriceRange, variants = [] } = product;

  const variantsHaveSamePrice = allVariantsHaveSamePrice(variants);

  const pricePerUnit =
    variants[0] && "pricePerUnit" in variants[0]
      ? (variants[0].pricePerUnit ?? undefined)
      : undefined;

  const transformedVariantPrice = variantPriceRange
    ? transformVariantPriceRange(variantPriceRange)
    : null;

  if (!transformedVariantPrice) return null;
  if (!isPriceAtLeastMinimumThreshold(transformedVariantPrice)) return null;

  const unitPriceInfo =
    pricePerUnit && variantsHaveSamePrice
      ? transformPricePerUnit(pricePerUnit)
      : undefined;

  const creditMessage = getCreditMessage(transformedVariantPrice, product);

  return (
    <PricePresentation
      transformedVariantPrice={transformedVariantPrice}
      creditMessage={creditMessage}
      product={product}
      configProps={configProps}
      unitPriceInfo={unitPriceInfo}
    />
  );
}
